import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import BluebirdPromise from 'bluebird';
import Async from 'react-select/async';
import { isUndefined } from 'lodash';
import { FeatureFlagContext } from '../../../common/FeatureFlagContext';

const PeopleSearchSelect = props => {
  const featureFlagConfig = useContext(FeatureFlagContext);
  const {
    selectedProfiles,
    handleSelect,
    name,
    allowNull = false,
    disabled = false,
    placeholder = 'Search...',
    isMulti = false,
    input,
    className,
    sortBy,
    initializeSearch = true,
    searchForParticipants,
    formOptions,
    membersById,
    defaultOpts = [],
    pathsContext,
    forceClear,
    tenantId,
    showValues = true,
    ...rest
} = props;

  const [valueObject, setValueObject] = useState(null);
  const includeUnpaid = featureFlagConfig.Paths_IncludeUnpaid;
  const useAEN = featureFlagConfig.Paths_AEN ?? false;

  function defaultOptions(defaultOpts) {
    return formOptions(defaultOpts, membersById) || [];
  }

  function loadOptions(values){

    let searchResultPromise = BluebirdPromise.resolve();
    if (values !== '' || initializeSearch) {
      searchResultPromise = searchForParticipants({pathsContext, name: values, includeUnpaid, useAEN, tenantId });
    }

    return searchResultPromise.then(res => {
        if (res) {
            const results = res.results;

            if (sortBy) {
                results.sort(
                    typeof sortBy === `function`
                    ? sortBy
                    : (a, b) => (a[sortBy]?.toUpperCase() > b[sortBy]?.toUpperCase() ? 1 : -1)
                );
            }

            const options = formOptions(results, membersById) || [];

            if (isMulti && valueObject && valueObject.length) {
                return [...options, ...valueObject];
            }

            return options;
        }
        return [];
    });
  };

  function onInputChange(item) {
    if (item && handleSelect) {
      setValueObject(item);
      handleSelect(item);
    } else if (item) {
        setValueObject(item);
    } else {
        setValueObject(null);
      if (allowNull && handleSelect && !isUndefined(item)) {
        handleSelect(item);
      }
    }
    if (input && input.onChange) {
      if (item) {
        input.onChange(item.value);
      } else {
        input.onChange(item);
      }
    }
  }

  const defaultOptionsList = defaultOptions(defaultOpts);

  // clears selected members when adding members to team
  if (forceClear && valueObject !== null) {
    setValueObject(null);
  }

    return (
        <Async
            {...input}
            {...rest}
            defaultOptions={defaultOptionsList}
            loadOptions={loadOptions}
            isClearable={true}
            className={`search-select verb-select ${className}`}
            value={showValues ? valueObject : null}
            isMulti={isMulti}
            placeholder={placeholder}
            onChange={onInputChange}
            isDisabled={disabled}
            classNamePrefix={'verb-select'}
            isOptionDisabled={option => option.isDisabled}
        />
    );
};

PeopleSearchSelect.propTypes = {
  formOptions: PropTypes.func,
  indexName: PropTypes.string,
  className: PropTypes.string,
  isMulti: PropTypes.bool,
  handleSelect: PropTypes.func,
  searchForParticipants: PropTypes.func,
  handleLoadOptions: PropTypes.func,
  forceClear: PropTypes.bool,
  input: PropTypes.object,
  membersById: PropTypes.object,
  initialValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  allowNull: PropTypes.bool,
  hitsPerPage: PropTypes.number,
  sortBy: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  pathsContext: PropTypes.object,
};

export default PeopleSearchSelect;